"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoginInfoInCommonHelper = exports.getSearch = exports.goToHash = exports.updateSearchParam = exports.go = exports.getRouteParams = exports.getPreviousStateName = exports.getRouteName = exports.getHref = exports.getInjector = void 0;
var typedi_1 = require("typedi");
var Browser_service_1 = require("../../services/Browser.service");
function getInjector() {
    var _a, _b;
    return (_b = (_a = window.angular) === null || _a === void 0 ? void 0 : _a.element(document.body)) === null || _b === void 0 ? void 0 : _b.injector();
}
exports.getInjector = getInjector;
function getHref(template, params, options) {
    var _a;
    try {
        var $state = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('$state');
        return $state.href(template, params, options);
    }
    catch (ex) {
        console.error('Failed to do angular routing', ex);
        return '';
    }
}
exports.getHref = getHref;
function getRouteName() {
    var _a;
    try {
        var $state = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('$state');
        return $state.current.name;
    }
    catch (ex) {
        console.error('Failed to do angular routing', ex);
    }
}
exports.getRouteName = getRouteName;
function getPreviousStateName() {
    var _a;
    try {
        var $state = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('$state');
        // $state.previous doesnt seem to exist. Does this work?
        return $state.previous;
    }
    catch (ex) {
        console.error('Failed to do angular routing', ex);
        return '';
    }
}
exports.getPreviousStateName = getPreviousStateName;
function getRouteParams() {
    var _a;
    try {
        var $state = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('$state');
        return $state.params;
    }
    catch (ex) {
        console.error('Failed to do angular routing', ex);
    }
}
exports.getRouteParams = getRouteParams;
function go(routeTemplate, queryParams, options) {
    var _a;
    try {
        var $state = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('$state');
        $state.go(routeTemplate, queryParams, options);
    }
    catch (ex) {
        console.error('Failed to do angular routing', ex);
    }
}
exports.go = go;
function updateSearchParam(paramName, newValue) {
    var _a;
    var $location = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('$location');
    try {
        return $location.search(paramName, newValue);
    }
    catch (ex) {
        console.error('Failed to do angular routing', ex);
    }
}
exports.updateSearchParam = updateSearchParam;
function goToHash(hash, queryParams) {
    var _a, _b;
    var browserService = typedi_1.Container.get(Browser_service_1.BrowserService);
    var hashToGoTo = browserService.isIE() ? hash : decodeURIComponent(hash);
    window.location.hash = hashToGoTo.startsWith('#') ? hashToGoTo : "#" + hashToGoTo;
    try {
        var $location = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('$location');
        $location === null || $location === void 0 ? void 0 : $location.url(hash).search(queryParams || {});
        var $rootScope = (_b = getInjector()) === null || _b === void 0 ? void 0 : _b.get('$rootScope');
        $rootScope.$applyAsync(); // Since this is called outside of angular scope, we must call $applyAsync
    }
    catch (ex) {
        console.error('Failed to do angular routing', ex);
    }
}
exports.goToHash = goToHash;
function getSearch() {
    var _a;
    try {
        var $location = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('$location');
        return $location.search();
    }
    catch (ex) {
        console.error('Failed to do angular routing', ex);
    }
}
exports.getSearch = getSearch;
function getLoginInfoInCommonHelper() {
    var _a, _b, _c;
    return (_c = (_b = (_a = getInjector()) === null || _a === void 0 ? void 0 : _a.get('commonHelper')) === null || _b === void 0 ? void 0 : _b.$App) === null || _c === void 0 ? void 0 : _c.loginInfo;
}
exports.getLoginInfoInCommonHelper = getLoginInfoInCommonHelper;
//# sourceMappingURL=angular-utils.js.map